module.exports = __webpack_public_path__ + "img/zfb.54ad6e1f.png";